import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaTherapist } from '@/service/tuina'

export const fetchTuinaTherapist = createAsyncThunk(
  'tuinaTherapistDetail/fetchTuinaTherapist',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaTherapist(query.id)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载师傅详情失败'
      )
    }
  }
)

const therapistDetailSlice = createSlice({
  name: 'tuinaTherapistDetail',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaTherapist.pending, (state) => {
        state.fetching = true
        state.error = null
        state.data = {}
      })
      .addCase(fetchTuinaTherapist.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || {}
      })
      .addCase(fetchTuinaTherapist.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default therapistDetailSlice.reducer
